export const SIGNUP_TITLE = "Get started with your Digital assistant";
export const SIGNUP_SUBTITLE =
  "Create your trial in seconds. You'll land in the Dashboard to manage your Digital assistant right away.";
export const SIGNUP_SUBMIT = "Next";
export const SIGNUP_MICRO = "No credit card required.";
export const SIGNUP_SUCCESS_TITLE = "Your account is ready";
export const SIGNUP_SUCCESS_BODY = (email) =>
  `We sent login details to ${email}. Check your inbox for your password.`;
export const SIGNUP_OPEN_DASHBOARD = "Open Dashboard";
export const SIGNUP_EXISTING_EMAIL =
  "This email is already registered. Please log in or use a different email.";
